import { UseFormReturn, useForm } from 'react-hook-form';
import { useCallback, useMemo } from 'react';
import { useOpportunitiesSearchParams } from '~/hooks/useSearchParams';
import { OpportunitiesSearchParams } from '~/contexts/types/opportunities/searchParams';

export type SearchFormData = {
  methods: UseFormReturn<OpportunitiesSearchParams>;
  onSubmit: () => void;
  handleReset: () => void;
};

const useSearchForm = (): SearchFormData => {
  const { searchParams, setSearchParams, defaultValues } = useOpportunitiesSearchParams();

  const methods = useForm<OpportunitiesSearchParams>({
    defaultValues: searchParams || defaultValues,
  });
  const { handleSubmit, reset } = methods;

  const handleReset = () => {
    reset(defaultValues);
    setSearchParams(defaultValues);
  };

  const onSubmit = useCallback(
    (data: OpportunitiesSearchParams) => {
      setSearchParams(data);
    },
    [setSearchParams]
  );

  return {
    onSubmit: useMemo(() => handleSubmit(onSubmit), [handleSubmit, onSubmit]),
    methods,
    handleReset,
  };
};

export default useSearchForm;
